import React, { ReactElement } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import '../../../repliconNavigation.css';
import { RepliconMenuHeader } from 'modules/common/RepliconMenu';
import { useRepliconNavigationContext } from '../hooks/RepliconNavigationProvider';

const useStyles = makeStyles({
  container: {
    display: 'flex'
  },
  mainContent: {
    width: '100vw',
    overflow: 'hidden'
  }
});

export const AdminRoutes = (): ReactElement => {
  const navigationMetadata = useRepliconNavigationContext();
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      {navigationMetadata && (
        <RepliconMenuHeader navigationMetadata={navigationMetadata} />
      )}
      <Box className={classes.mainContent}>
        <BrowserRouter
          basename={
            process.env.NODE_ENV === 'development'
              ? ''
              : navigationMetadata.companyKey
          }
        ></BrowserRouter>
      </Box>
    </Box>
  );
};
